module.exports = __webpack_public_path__ + "static/media/filled_bar_WPC.839f5dbe.svg";